
import { defineComponent, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { WarningOutline as WarningIcon } from '@vicons/ionicons5';
import regionService from '@/services/region-service';
import { Region } from '@/types';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'ConfirmRegionDeleteModal',
  props: {
    region: {
      type: Object as () => Region,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  components: { WarningIcon },
  setup(props, { emit }) {
    const showModalRef = useVModel(props, 'showModal');
    const showToast = inject<ShowToast>('showToast')!;
    const confirmDelete = () => {
      if (props.region.managerIds.length > 0 || props.region.surveyCount > 0) {
        showToast({
          headline: 'Error',
          message: 'Cannot delete a region with users or surveys tied to it',
          color: 'danger'
        });
        showModalRef.value = false;
      } else {
        regionService
          .delete(props.region.id)
          .then(() => {
            emit('region-update');
          })
          .catch(() => {
            showToast({
              headline: 'Error',
              message: 'Failed to delete region',
              color: 'danger'
            });
          })
          .finally(() => {
            showModalRef.value = false;
          });
      }
    };

    const cancelDelete = () => {
      showModalRef.value = false;
    };

    return {
      confirmDelete,
      cancelDelete,
      showModalRef
    };
  }
});
